$(document).ready(function () {
  if ($("input[name='ai[b_coupon]']") != undefined) {
    $("input[name='ai[b_coupon]']").change(function () {
      $("input[name='ai[b_coupon]']").val($("input[name='ai[b_coupon]']").val().replace(/[^a-zA-Z0-9äöüÄÖÜß_@.\/#+\-%\s]/, ''));
    });
  }
  $('.data-mobile-filter-toggle').on('click', function (event) {
      if (window.matchMedia('(max-width: 991px)').matches) {
        $(this).toggleClass('open');
        $(this).parent().find("ul").slideToggle();
      }
    }
  );
});
(function () {

  Aimeos.createContainer = function (content) {

    var container = $(document.createElement("div"));
    var btnclose = $(document.createElement("a"));

    btnclose.text("X");
    btnclose.addClass("c-basket__button--close");
    btnclose.addClass("btn-close");

    container.addClass("c-basket aimeos-container");
    container.addClass("aimeos");
    container.prepend(btnclose);
    container.fadeTo(400, 1.0);
    container.append(content);

    $("body").append(container);

    var resize = function () {
      var jqwin = $(window);
      var left = (jqwin.width() - container.outerWidth()) / 2;
      var top = jqwin.scrollTop() + (jqwin.height() - container.outerHeight()) / 2;

      container.css("left", (left > 0 ? left : 0));
      container.css("top", (top > 0 ? top : 0));
    };

    $(window).on("resize", resize);
    resize();
    if ($("input[name='ai[b_coupon]']") != undefined) {
      $("input[name='ai[b_coupon]']").change(function () {
        $("input[name='ai[b_coupon]']").val($("input[name='ai[b_coupon]']").val().replace(/[^a-zA-Z0-9äöüÄÖÜß_@.\/#+\-%\s]/, ''));
      });
    }
  }
  //Deactivate toggles
  AimeosCatalogFilter.setupAttributeToggle = function () {
  }
  AimeosCatalogFilter.setupAttributeListsToggle = function () {
  }

  AimeosCatalogList.setupInfiniteScroll = function () {


    var url = $('.catalog-list-items').data('infinite-url');

    if (typeof url === "string" && url != '') {

      $(window).on('scroll', function () {

        var list = $('.catalog-list-items').first();

        var infiniteUrl = list.data('infinite-url');
        if (infiniteUrl && list[0].getBoundingClientRect().bottom - $(window).height() < 50) {

          list.data('infinite-url', '');

          $('#loading-animation').show();
          $.ajax({
            url: infiniteUrl
          }).fail(function () {
            list.data('infinite-url', infiniteUrl);
          }).done(function (response) {
            var nextPage = $(response);

            nextPage.find('.catalog-list-items  .product').each(function () {

              $('.list-items', list).append(this);
            });
            $('#loading-animation').hide();

            var nextUrl = nextPage.find('.catalog-list-items').data('infinite-url');
            list.data('infinite-url', nextUrl);
            $(window).trigger('scroll');
          });
        }
      });
    }
  }


  AimeosBasketMini.setupBasketToggle = function () {
  }

  AimeosBasketMini.updateBasket = function (basket) {

    if (!(basket.data && basket.data.attributes)) {
      return;
    }

    var attr = basket.data.attributes;
    var price = Number.parseFloat(attr['order.base.price']);
    var delivery = Number.parseFloat(attr['order.base.costs']);

    var formatter = new Intl.NumberFormat([], {
      currency: attr['order.base.currencyid'],
      style: "currency"
    });

    $(".aimeos .basket-mini-main .value").html(formatter.format(price + delivery));
    $(".aimeos .basket-mini-product .total .price").html(formatter.format(price + delivery));
    $(".aimeos .basket-mini-product .delivery .price").html(formatter.format(delivery));

    if (basket.included) {

      var csrf = '';
      var count = 0;
      var body = $(".aimeos .basket-mini-product .basket-body");
      var prototype = $(".aimeos .basket-mini-product .product.prototype");

      if (basket.meta && basket.meta.csrf) {
        csrf = basket.meta.csrf.name + '=' + basket.meta.csrf.value;
      }

      $(".aimeos .basket-mini-product .product").not(".prototype").remove();

      for (var i = 0; i < basket.included.length; i++) {
        var entry = basket.included[i];

        if (entry.type === 'basket/product') {
          var product = prototype.clone();

          product.data("urldata", csrf);
          product.data("url", entry.links.self.href);

          $(".name", product).html(entry.attributes['order.base.product.name']);
          $(".quantity", product).html(entry.attributes['order.base.product.quantity']);
          $(".price", product).html(formatter.format(entry.attributes['order.base.product.price']));

          body.append(product.removeClass("prototype"));

          count += Number.parseInt(entry.attributes["order.base.product.quantity"]);
        }
      }

      $(".aimeos  #quantity").html(count);
    }
  }

})();
